/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_UtilitiesInputs */

const en_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilities Available`)
};

const es_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicios públicos disponibles`)
};

const fr_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services publics disponibles`)
};

const de_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Versorgungsanschlüsse`)
};

const ja_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なインフラ(電気・水道等)`)
};

const zh_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用公用设施`)
};

const ar_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المرافق الخدمية المتاحة`)
};

const id_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilitas Tersedia`)
};

const it_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utenze Disponibili`)
};

const ru_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступные коммуникации`)
};

const pt_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviços Públicos Disponíveis`)
};

const ko_field_utilities = /** @type {(inputs: Field_UtilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용 가능 시설(수도, 전기 등)`)
};

/**
* | output |
* | --- |
* | "Utilities Available" |
*
* @param {Field_UtilitiesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_utilities = /** @type {((inputs?: Field_UtilitiesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_UtilitiesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_utilities(inputs)
	if (locale === "es") return es_field_utilities(inputs)
	if (locale === "fr") return fr_field_utilities(inputs)
	if (locale === "de") return de_field_utilities(inputs)
	if (locale === "ja") return ja_field_utilities(inputs)
	if (locale === "zh") return zh_field_utilities(inputs)
	if (locale === "ar") return ar_field_utilities(inputs)
	if (locale === "id") return id_field_utilities(inputs)
	if (locale === "it") return it_field_utilities(inputs)
	if (locale === "ru") return ru_field_utilities(inputs)
	if (locale === "pt") return pt_field_utilities(inputs)
	return ko_field_utilities(inputs)
});